import Vue from 'vue'
import './assets/style/reset.css'
import './assets/style/common.css'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import './utils/date'
import { getParams, setAutograph } from '@/utils/index'

// 获取地址栏参数，设置登录信息
const queryParams = getParams()
setAutograph(queryParams)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
const VueScrollTo = require('vue-scrollto')

Vue.use(VueScrollTo)

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
